/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-empty */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../redux/actions'
import { Link, useParams, useHistory } from 'react-router-dom'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

// components
import { Box, Button, Flex, Select, Stack } from '@chakra-ui/react'
import SpinnerLoading from 'components/Loading/SpinnerLoading'
import ChartRenderingComponent from '../../components/Graphs/Functions/ChartRendering'
import ChartRenderingComponentSlide from '../../components/Graphs/Functions/ChartRenderingSlide'
import InfiniteScroll from 'react-infinite-scroll-component'
import dayjs from 'dayjs'

// ! ตอนนี้กราฟ จะ Rander ได้เฉพาะข้อมูลที่เป็น Number ยังไม่สามารถ Rerender จากข้อมูลที่เป็น Boolean ได้
export default function StationGraph({ sidebarStatus, setIsShowSidebar }) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  // const [currentStation, setcurrentStation] = useState()
  const [currentStationChart, setcurrentStationChart] = useState([])
  const [isFetchNewOne, setisFetchNewOne] = useState(true)
  const [isFirstTime, setIsFirstTime] = useState(true)
  const dispatch = useDispatch()
  const params = useParams()
  const currentStation = useSelector((state) => state.station)
  const allLogs = useSelector((state) => state.log)
  const allPredictionLogs = useSelector((state) => state.logPrediction)
  const [graphMin, setGraphMin] = useState(undefined)
  const [graphMax, setGraphMax] = useState(undefined)
  const [tickAmount, setTickAmount] = useState(8)
  const [valueFormat, setValueFormat] = useState('HH:mm')
  const [graph4, setGraph4] = useState('')
  const [selectType, setSelectType] = useState('slide01')
  const me = useSelector((state) => state.me)
  const history = useHistory()
  const [testArray, setTestArray] = useState(5)

  const fetchMoreData = () => {
    // a fake async api call like which sends
    // 20 more records in 1.5 secs
    console.log('fetchMoreData working')
    setTimeout(() => {
      setTestArray(testArray + 5)
    }, 2000)
  }

  useEffect(() => {
    if (me && me._id && currentStation) {
      if (_.includes(me.duty, 'ALLAREA') || me.duty === currentStation._id) {
      } else {
        console.log('ผู้ใช้ไม่มีสิทธิเข้าใช้')
      }
    }
    return () => {}
  }, [me, currentStation])

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(actions.stationGet(params.stationId))
        setisFetchNewOne(false)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData() // เรียกใช้งานฟังก์ชัน async ที่สร้างขึ้น
    setcurrentStationChart(currentStation?.charts?.slice(0, testArray))
    return () => {}
  }, [params.stationId, isFetchNewOne, testArray])

  useEffect(() => {
    const fetchLog = async () => {
      try {
        if (params.stationId) {
          console.log('Fetching the log Firsttime or not', isFirstTime)
          if (isFirstTime === true) {
            dispatch(
              actions.logOnDaySpecific(
                params.stationId,
                dayjs().toDate(),
                dayjs().toDate(),
                'log1mm'
              )
            ).then(() => {
              setTimeout(() => {
                setIsLoading(true)
              }, 1000)
            })

            setIsLoading(true)
          } else {
            dispatch(
              actions.logOnDaySpecific(
                params.stationId,
                dayjs().toDate(),
                dayjs().toDate(),
                'log1mm'
              )
            )
            setIsLoading(true)
          }
        }
      } catch (error) {
        console.error('Error fetching station data:', error)
      }
    }

    fetchLog()
    return () => {}
  }, [isFetchNewOne, params.stationId, params.groupId])

  useEffect(() => {
    if (isFetchNewOne === false) {
      setTimeout(() => {
        setisFetchNewOne(true)
      }, 60000)
      //ปรับกราฟใหม่ ทุกๆ 60 วินาที
    }
    return () => {}
  }, [isFetchNewOne])

  const settingsSlide = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    lazyLoad: true,
    slidesToScroll: 1,
    autoplay: false,
    rows: 5,
    speed: 500,
    autoplaySpeed: 5000,
    cssEase: 'linear',
  }
  const handleSelectType = (e) => {
    setSelectType(e.target.value)
  }
  // console.log('currentStation.charts', currentStation?.charts)

  const GroupChart = _.chunk(
    _.orderBy(currentStation?.charts, 'orderLevel', 'asc'),
    4
  )

  const lastHour = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1mm')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }

  const lastDay = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1h')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }

  const lastWeek = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1d')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }

  const lastMonth = () => {
    let timeOut
    dispatch(
      actions.logOnDaySpecific(params.stationId, graphMin, graphMax, 'log1d')
    ).then(() => {
      timeOut = setTimeout(() => {
        setIsLoading(true)
      }, 2000)
    })

    if (timeOut) {
      clearTimeout(timeOut)
    }
  }

  return currentStation ? (
    <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
      <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div className="flex flex-wrap items-center">
          <div className="relative w-full max-w-full flex-grow flex-1">
            <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans ">
              {t('dashboard.dashboardMonitor')}
            </h6>
            <h2 className="text-gray-800 text-2xl font-bold font-sans">
              {t('dashboard.graph')} {currentStation.name}
            </h2>
            <p className="text-base text-gray-500 mb-1  font-sans ">
              {currentStation.location}
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-between p-4">
        <div className="flex justify-items-start">
          <Select
            placeholder="รูปแบบการโชว์"
            type="text"
            name="electricType"
            defaultValue={selectType}
            onChange={handleSelectType}
          >
            <option value="slide01">สไลด์โชว์</option>
            <option value="slide02">ไม่สไลด์โชว์</option>
          </Select>
        </div>
        <div className="flex justify-items-end">
          <Button
            colorScheme="blue"
            variant="solid"
            size="sm"
            onClick={() => {
              if (graph4 === 'grid-cols-2') {
                setGraph4('')
              } else {
                setGraph4('grid-cols-2')
              }
            }}
          >
            แสดง 4 กราฟ
          </Button>
          <Button
            colorScheme="gray"
            variant="solid"
            size="sm"
            onClick={() => setIsShowSidebar(!sidebarStatus)}
          >
            {t('dashboard.toggleSidebar')}
          </Button>
        </div>
      </div>

      {selectType === 'slide01' ? (
        <div>
          {graph4 === 'grid-cols-2' ? (
            <Slider {...settingsSlide}>
              {_.map(GroupChart, (chart, index) => {
                return (
                  <div className={`grid sm:${graph4} p-4 w-full`}>
                    {_.map(chart, (e) => (
                      <div className="">
                        <ChartRenderingComponent
                          multichart={false}
                          key={index}
                          chartData={e}
                          data={allLogs}
                          dataPrediction={allPredictionLogs}
                          graphMax={graphMax}
                          graphMin={graphMin}
                          setGraphMax={setGraphMax}
                          setGraphMin={setGraphMin}
                          setTickAmount={setTickAmount}
                          setValueFormat={setValueFormat}
                          tickAmount={tickAmount}
                          valueFormat={valueFormat}
                          stationData={currentStation}
                          enableTimeSelect={true}
                        />{' '}
                        <Stack
                          direction={['column', 'row']}
                          spacing={['2', '4']}
                        >
                          <Button
                            size="sm"
                            onClick={() => {
                              lastHour()
                              setGraphMin(undefined)
                              setGraphMax(undefined)
                              // setGraphMin(moment().subtract('hours').toDate().getTime())
                              // setGraphMax(moment().ad('hours').toDate().getTime())

                              setTickAmount(10)
                              setValueFormat('HH:mm')
                            }}
                          >
                            {t('graph.hourAgo')}
                          </Button>
                          <Button
                            size="sm"
                            onClick={() => {
                              setGraphMin(
                                moment().subtract(1, 'days').toDate().getTime()
                              )
                              setGraphMax(
                                moment().add(2, 'hours').toDate().getTime()
                              )
                              setIsLoading(false)
                              lastDay()
                              setTickAmount(12)
                              setValueFormat('HH:mm')
                            }}
                          >
                            {t('graph.dayAgo')}
                          </Button>
                          <Button
                            size="sm"
                            onClick={() => {
                              setGraphMin(
                                moment().subtract(1, 'weeks').toDate().getTime()
                              )
                              setGraphMax(
                                moment().add(1, 'days').toDate().getTime()
                              )
                              setIsLoading(false)
                              lastWeek()
                              setTickAmount(7)
                              setValueFormat('DD MMM YYYY')
                            }}
                          >
                            {t('graph.weekAgo')}
                          </Button>
                          <Button
                            size="sm"
                            onClick={() => {
                              setGraphMin(
                                moment()
                                  .subtract(1, 'months')
                                  .toDate()
                                  .getTime()
                              )
                              setGraphMax(
                                moment().add(2, 'days').toDate().getTime()
                              )
                              setIsLoading(false)
                              setTickAmount(6)
                              lastMonth()
                              setValueFormat('DD MMM YYYY')
                            }}
                          >
                            {t('graph.monthAgo')}
                          </Button>
                        </Stack>
                      </div>
                    ))}
                  </div>
                )
              })}
            </Slider>
          ) : (
            <Slider {...settingsSlide}>
              {_.map(
                _.orderBy(currentStation?.charts, 'orderLevel', 'asc'),
                (chart, index) => (
                  <div className="p-4 w-full">
                    <ChartRenderingComponent
                      multichart={false}
                      key={index}
                      chartData={chart}
                      data={allLogs}
                      dataPrediction={allPredictionLogs}
                      graphMax={graphMax}
                      graphMin={graphMin}
                      setGraphMax={setGraphMax}
                      setGraphMin={setGraphMin}
                      setTickAmount={setTickAmount}
                      setValueFormat={setValueFormat}
                      tickAmount={tickAmount}
                      valueFormat={valueFormat}
                      stationData={currentStation}
                      enableTimeSelect={true}
                    />{' '}
                    <Stack direction={['column', 'row']} spacing={['2', '4']}>
                      <Button
                        size="sm"
                        onClick={() => {
                          lastHour()
                          setGraphMin(undefined)
                          setGraphMax(undefined)
                          // setGraphMin(moment().subtract('hours').toDate().getTime())
                          // setGraphMax(moment().ad('hours').toDate().getTime())

                          setTickAmount(10)
                          setValueFormat('HH:mm')
                        }}
                      >
                        {t('graph.hourAgo')}
                      </Button>
                      <Button
                        size="sm"
                        onClick={() => {
                          setGraphMin(
                            moment().subtract(1, 'days').toDate().getTime()
                          )
                          setGraphMax(
                            moment().add(2, 'hours').toDate().getTime()
                          )
                          setIsLoading(false)
                          lastDay()
                          setTickAmount(12)
                          setValueFormat('HH:mm')
                        }}
                      >
                        {t('graph.dayAgo')}
                      </Button>
                      <Button
                        size="sm"
                        onClick={() => {
                          setGraphMin(
                            moment().subtract(1, 'weeks').toDate().getTime()
                          )
                          setGraphMax(
                            moment().add(1, 'days').toDate().getTime()
                          )
                          setIsLoading(false)
                          lastWeek()
                          setTickAmount(7)
                          setValueFormat('DD MMM YYYY')
                        }}
                      >
                        {t('graph.weekAgo')}
                      </Button>
                      <Button
                        size="sm"
                        onClick={() => {
                          setGraphMin(
                            moment().subtract(1, 'months').toDate().getTime()
                          )
                          setGraphMax(
                            moment().add(2, 'days').toDate().getTime()
                          )
                          setIsLoading(false)
                          setTickAmount(6)
                          lastMonth()
                          setValueFormat('DD MMM YYYY')
                        }}
                      >
                        {t('graph.monthAgo')}
                      </Button>
                    </Stack>
                  </div>
                )
              )}
            </Slider>
          )}
        </div>
      ) : (
        <div className={`grid sm:${graph4} p-4 w-full`}>
          <InfiniteScroll
            dataLength={currentStation?.charts?.length}
            next={fetchMoreData}
            hasMore={true}
            loader={<h4>Loading...</h4>}
          >
            {/* {_.map(
              _.orderBy(currentStation.charts, 'orderLevel', 'asc'),
              (chart, index) => (
                <div>{index}</div>
              )
            )} */}
            {_.map(currentStation?.charts, (chart, index) => (
              <div>
                <ChartRenderingComponent
                  multichart={false}
                  key={index}
                  chartData={chart}
                  data={allLogs}
                  dataPrediction={allPredictionLogs}
                  graphMax={graphMax}
                  graphMin={graphMin}
                  setGraphMax={setGraphMax}
                  setGraphMin={setGraphMin}
                  setTickAmount={setTickAmount}
                  setValueFormat={setValueFormat}
                  tickAmount={tickAmount}
                  valueFormat={valueFormat}
                  stationData={currentStation}
                  enableTimeSelect={true}
                />{' '}
                <Stack direction={['column', 'row']} spacing={['2', '4']}>
                  <Button
                    size="sm"
                    onClick={() => {
                      lastHour()
                      setGraphMin(undefined)
                      setGraphMax(undefined)
                      // setGraphMin(moment().subtract('hours').toDate().getTime())
                      // setGraphMax(moment().ad('hours').toDate().getTime())

                      setTickAmount(10)
                      setValueFormat('HH:mm')
                    }}
                  >
                    {t('graph.hourAgo')}
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => {
                      setGraphMin(
                        moment().subtract(1, 'days').toDate().getTime()
                      )
                      setGraphMax(moment().add(2, 'hours').toDate().getTime())
                      setIsLoading(false)
                      lastDay()
                      setTickAmount(12)
                      setValueFormat('HH:mm')
                    }}
                  >
                    {t('graph.dayAgo')}
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => {
                      setGraphMin(
                        moment().subtract(1, 'weeks').toDate().getTime()
                      )
                      setGraphMax(moment().add(1, 'days').toDate().getTime())
                      setIsLoading(false)
                      lastWeek()
                      setTickAmount(7)
                      setValueFormat('DD MMM YYYY')
                    }}
                  >
                    {t('graph.weekAgo')}
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => {
                      setGraphMin(
                        moment().subtract(1, 'months').toDate().getTime()
                      )
                      setGraphMax(moment().add(2, 'days').toDate().getTime())
                      setIsLoading(false)
                      setTickAmount(6)
                      lastMonth()
                      setValueFormat('DD MMM YYYY')
                    }}
                  >
                    {t('graph.monthAgo')}
                  </Button>
                </Stack>
              </div>
            ))}
          </InfiniteScroll>
        </div>
      )}
    </div>
  ) : (
    <SpinnerLoading />
  )
}
